// extracted by mini-css-extract-plugin
export default {"statsGrid":"AdminRewards_statsGrid__oE9BO","statCard":"AdminRewards_statCard__uk-0O","statIcon":"AdminRewards_statIcon__LLEtJ"};